import { Injectable } from '@angular/core';
import { Pageable } from '@peca/backoffice/models/pageable.model';
import { BaseHttpClient } from '@peca/commons';
import { environment } from 'apps/backoffice/src/environments/environment';
import { InboundInvoiceQuery } from '../models/fiscal/inbound-invoice-query.model';
import { InboundInvoice } from '../models/fiscal/inbound-invoice.model';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InboundInvoicesService extends BaseHttpClient {
  readonly baseUrl: string;
  readonly sefazUrl: string;

  constructor() {
    super();
    this.baseUrl = `${environment.gateway.url}/backoffice/v2/inbound-invoices`;
    this.sefazUrl = environment.sefaz.url;
  }

  goToSefazConsultNfe(key: string) {
    const url = new URL(`${this.sefazUrl}/portal/consultaRecaptcha.aspx`);
    url.searchParams.set('tipoConsulta', 'resumo');
    url.searchParams.set('tipoConteudo', '7PhJ+gAVw2g=');
    url.searchParams.set('nfe', key);

    window.open(url.toString(), '_blank', 'noopener,noreferrer');
  }

  fetchInboundInvoices(query: InboundInvoiceQuery) {
    const params = this.prepareQuery(query);
    return this.http.get<Pageable<InboundInvoice>>(this.baseUrl, { params });
  }

  archiveInboundInvoice(id: string, archive: boolean): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${id}`, {
      fiscalArchived: archive,
    });
  }

  suggestions(search: string, reconciled: boolean | null = null, fiscalArchived: boolean | null = null) {
    const params = this.prepareQuery({
      search,
      reconciled,
      fiscalArchived,
    });
    return this.http
      .get<InboundInvoice[]>(`${this.baseUrl}/suggestions`, { params })
      .pipe(map((items) => items.map(({ id, code, branch }) => ({ id, label: code, description: branch.companyName }))));
  }
}
